export const routeCodes = {
	base: ``,
	banks: `/banks/banks`,
	bankLoginPage: `/banks/bank-login`,
	bankSessionOverviewPage: `/banks/bank-session-overview`,
}

export type TransactionDataValidationStatus = {
	hasThreeMonthsOfTransactions: boolean
	hasEnoughTransactionsLastMonth: boolean
	hasEnoughTransactionsLastQuarter: boolean
}

export type BankDto = {
	id: number
	displayName: string
	favorite: boolean
	serviceProviderId: number
	bankId: string
	iconUrl: string
	imageUrl: string
}

export interface BankToAdd {
	id: number
	name: string
}

export const BankServiceProviders = {
	None: 0,
	BankData: 2,
	BEC: 3,
	DanskeBank: 4,
	Nordea: 5,
	SDC: 6,
	Test: 7,
	CustomTest: 9,
	Aiia: 10,
	Dnb: 11,
	EnableBanking: 12,
	Swedbank: 13,
	DemoProfiles: 14,
}

export type GetAllBankSessionsResponseDto = {
	bankSessions: BankSession[]
}

export type BankSession = {
	bankId: number
	accounts: BankAccountDto[]
}

export interface BankAccountDto {
	name?: string
	accountNumber?: string
	type?: string
	owner?: string
	accountId: string
	selected: boolean
}

export interface BankLoginUrlDto {
	authUrl: string
	usePopup: boolean
	usePsd2Consent: boolean
}

export interface ConsumerAuthenticationDto {
	token: string
	finishedOn: Date | null
	psd2Consent: Psd2ConsentDto
}

export interface Psd2ConsentDto {
	isConsentGiven: boolean
	psD2ConsentTranslations: Psd2ConsentTranslation[]
}

export type Psd2ConsentTranslation = {
	header: string
	text: string
	languageCode: string
}

export type Psd2ConsentType = 'transactionsAndAccounts' | 'accounts'

export type RegisterSessionAndGetConsentInput = {
	ConsentType: Psd2ConsentType
}

export type BankError = {
	name: string
	errorText: string
	errorCode: string
	data: any
}

export type FetchBankSessionsTransactionsResponseDto = {
	clearBudgetAndDebtData: boolean
	banksToAdd: BankToAdd[]
	transactionDataValidation: TransactionDataValidationStatus
} | null
